import {
  ErrorMessages,
  SharedFeature,
  checkDefined,
  getFullPageError
} from '@com-delta-idp/mnx-skymiles-shared';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as Adapters from '../../adapters';
import { Configs } from '../../models/aem/overview.interface';
import {
  OVERVIEW_FEATURE_KEY,
  State,
  overviewAdapter
} from '../reducers/overview.reducer';

// Lookup the 'Shared' feature state managed by NgRx
export const getSharedState = createFeatureSelector<SharedFeature.State>(
  SharedFeature.SHARED_FEATURE_KEY
);

const { selectEntities: selectSharedEntities } =
  SharedFeature.sharedAdapter.getSelectors();

export const getSharedEntities = createSelector(
  getSharedState,
  (state: SharedFeature.State) => {
    return selectSharedEntities(state);
  }
);

// Lookup the 'Overview' feature state managed by NgRx
export const getOverviewState =
  createFeatureSelector<State>(OVERVIEW_FEATURE_KEY);

const { selectEntities } = overviewAdapter.getSelectors();

export const getOverviewError = createSelector(
  getOverviewState,
  (state: State) => state.error
);

export const getOverviewEntities = createSelector(
  getOverviewState,
  (state: State) => selectEntities(state)
);

export const getCarrierCode = createSelector(getOverviewEntities, (entities) =>
  checkDefined(entities['aem-content']?.aemContent?.requestProperty.carrierCode)
);

export const getOnboarding = createSelector(
  getOverviewEntities,
  getSharedEntities,
  (overviewEntities, sharedEntities) =>
    Adapters.getOnboarding(
      overviewEntities['aem-feature-flags']?.aemFeatureFlags?.flags.overview
        .onboarding,
      sharedEntities['user-session']?.userSession,
      overviewEntities['multiple-pe-content']?.multiplePEContent,
      overviewEntities['multiple-pe-content-error']?.multiplePEContentError
    )
);

export const getServiceConfiguration = createSelector(
  getOverviewEntities,
  (overviewEntities) =>
    Adapters.getServiceConfiguration(
      overviewEntities['aem-summary-content']?.aemSummaryContent?.configs ||
        ({} as Configs)
    )
);

export const getFullPageErrorMessage = createSelector(
  getOverviewEntities,
  (overviewEntities) =>
    getFullPageError(
      [
        overviewEntities['aem-content-error']?.aemContentError,
        overviewEntities['aem-feature-flags-error']?.aemFeatureFlagsError,
        overviewEntities['aem-summary-content-error']?.aemSummaryContentError,
        overviewEntities['aem-error-messages-error']?.aemErrorMessagesError
      ],
      ErrorMessages
    )
);

export const getFlags = createSelector(
  getOverviewEntities,
  (entities) => entities['aem-feature-flags']?.aemFeatureFlags?.flags
);
